import apiClient from '@shared/api'
import type IOrganization from '@shared/api/user-management/resources/organization/organization'
import type IOrganizationCommunity from '@shared/api/user-management/resources/organization/organization-community'
import type IOrganizationUser from '@shared/api/user-management/resources/organization/organization-user'
import type ICreateCommunity from '@shared/api/user-management/resources/organization/create-community'
import type ICreateUser from '@shared/api/user-management/resources/organization/users/create-user'

export const getOrganizationList = (): Promise<IOrganization[]> => {
  return apiClient.get('/organizations')
}

export const getOrganizationById = ({
  organizationId,
}: {
  organizationId: string | string[]
}): Promise<IOrganization> => {
  return apiClient.get(`/organizations/${organizationId}`)
}

export const getOrganizationCommunityList = ({
  organizationId,
}: {
  organizationId: string | string[]
}): Promise<IOrganizationCommunity[]> => {
  return apiClient.get(`/organizations/${organizationId}/communities`)
}

export const createNewOrganization = ({ name }: { name: string }): Promise<IOrganization> => {
  return apiClient.post('/organizations', { name })
}

export const getOrganization = ({ organizationId }: { organizationId: string | string[] }): Promise<IOrganization> => {
  return apiClient.get(`/organizations/${organizationId}`)
}

export const getOrganizationUsers = ({
  organizationId,
}: {
  organizationId: string | string[]
}): Promise<IOrganizationUser[]> => {
  return apiClient.get(`/organizations/${organizationId}/users`)
}

export const createNewCommunity = ({
  organizationId,
  locationData,
}: {
  organizationId: string | string[]
  locationData: ICreateCommunity
}): Promise<IOrganizationCommunity> => {
  return apiClient.post(`/organizations/${organizationId}/communities`, locationData)
}

export const createNewUser = ({
  organizationId,
  userData,
}: {
  organizationId: string | string[]
  userData: ICreateUser
}): Promise<IOrganizationCommunity> => {
  return apiClient.post(`/organizations/${organizationId}/users`, userData)
}

export const deleteUser = ({
  organizationId,
  userId,
}: {
  organizationId: string | string[]
  userId: string | string[]
}): Promise<{ roles: any[] }> => {
  return apiClient.delete(`/organizations/${organizationId}/users/${userId}`)
}

export const deactivateOrganization = ({ organizationId }: { organizationId: string | string[] }) => {
  return apiClient.post(`/organizations/${organizationId}/deactivate`)
}
